<template>
  <div class="dashboard">
    <!-- HEADER -->
    <div class="header">
      <h2>Thống kê</h2>

      <div class="header-right">
        <div class="sortTime" @click="togglePopover">
          <label>📅 Thời gian</label>
        </div>
        <div v-if="showPopover" class="popover">
          <div class="popover-inner">
            <div class="option" @click="getDailyStatistics">Hôm nay</div>
            <div class="option" @click="getWeeklyStatistics">7 ngày qua</div>
            <div class="option" @click="getThirtyDaysStatistics">30 ngày qua</div>

            <div class="divider"></div>
            <div class="custom-range">
              <span>Từ: </span>
              <input type="date" v-model="filters.from_date" />
              <span>Đến: </span>
              <input type="date" v-model="filters.to_date" />
              <button class="btn-apply" @click="applyCustom">Áp dụng</button>
            </div>
          </div>
        </div>
        <input class="search" placeholder="Search..." />
        <button class="btn-report">Tạo báo cáo</button>
      </div>
    </div>

    <!-- KPI -->
    <div class="kpi-grid">
      <div class="kpi-card purple">
        <h3>{{ formatCurrency(stats.data.total_revenue) }}</h3>
        <p>Doanh thu thuần</p>
      </div>

      <div class="kpi-card blue">
        <h3>{{ formatCurrency(stats.data.total_discount) }}</h3>
        <p>Phiếu giảm giá</p>
      </div>

      <div class="kpi-card orange">
        <h3>{{ stats.data.total_products }}</h3>
        <p>Sản phẩm đã bán</p>
      </div>

      <div class="kpi-card pink">
        <h3>{{ stats.total_customers }}</h3>
        <p>Lượt xem trang</p>
      </div>
    </div>

    <!-- CHART ROW -->
    <div class="grid-2">
      <div class="card">
        <h3>Thống kê sự kiện</h3>
        <canvas id="chart1"></canvas>
      </div>

      <div class="card">
        <h3>Thống kê sự kiện</h3>
        <canvas id="chart2"></canvas>
      </div>
    </div>

    <!-- BOTTOM -->
    <!-- <div class="grid-2">
      <div class="card">
        <h3>Thống kê lợi nhuận</h3>
        <canvas id="chart3"></canvas>
      </div>

      <div class="card">
        <h3>Phiếu giảm giá</h3>
        <canvas id="chart4"></canvas>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
// import Chart from "chart.js/auto";
import { statisticsApi } from "@/services/api";
import { formatCurrency } from "@/utils/helpers";
import { useToast } from "@/composables/useToast";
// import { reactive } from "vue";

const toast = useToast();
const showPopover = ref(false);
const filters = {
  from_date: "",
  to_date: "",
};
const stats = ref({
  data: 0,
  total_receipts: 0,
  total_products: 0,
  total_customers: 0,
  top_products: [],
  chart: [],
});

const fetchMonthlyStatistics = async () => {
  try {
    const res = await statisticsApi.getMonthlyStatistics();
    stats.value = { ...stats.value, ...res.data };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Error fetching monthly statistics";
    toast.error(errorMessage);
    console.error("Error applying custom filters:", error);
  }
};

onMounted(() => {
  fetchMonthlyStatistics();
});
// onMounted(
// () => {
//   new Chart(document.getElementById("chart1"), {
//     type: "doughnut",
//     data: {
//       labels: ["Jan", "Feb", "Mar"],
//       datasets: [
//         {
//           data: [40, 30, 30],
//           backgroundColor: ["#8b5cf6", "#facc15", "#22d3ee"],
//         },
//       ],
//     },
//   });

//   new Chart(document.getElementById("chart2"), {
//     type: "line",
//     data: {
//       labels: ["Jan", "Feb", "Mar", "Apr", "May"],
//       datasets: [
//         {
//           label: "Sales",
//           data: [100, 200, 150, 300, 250],
//           borderColor: "#22d3ee",
//           tension: 0.4,
//         },
//       ],
//     },
//   });

//   new Chart(document.getElementById("chart3"), {
//     type: "line",
//     data: {
//       labels: ["Jan", "Feb", "Mar", "Apr"],
//       datasets: [
//         {
//           data: [200, 300, 250, 400],
//           borderColor: "#f472b6",
//           tension: 0.4,
//           fill: true,
//         },
//       ],
//     },
//   });

//   new Chart(document.getElementById("chart4"), {
//     type: "bar",
//     data: {
//       labels: ["Mon", "Tue", "Wed", "Thu"],
//       datasets: [
//         {
//           data: [50, 70, 60, 90],
//           backgroundColor: "#facc15",
//         },
//       ],
//     },
//   });
// }
// );

const togglePopover = () => {
  showPopover.value = !showPopover.value;
};

const applyCustom = async () => {
  try {
    const res = await statisticsApi.getCustomStatistics(filters);
    stats.value = { ...stats.value, ...res.data };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Error applying custom filters";
    toast.error(errorMessage);
    console.error("Error applying custom filters:", error);
  }
};

const getWeeklyStatistics = async ()=>{
    try {
        const res = await statisticsApi.getWeeklyStatistics();
        stats.value = { ...stats.value, ...res.data };
    } catch (error) {
        const errorMessage =
        error.response?.data?.message || "Error fetching weekly statistics";
        toast.error(errorMessage);
        console.error("Error fetching weekly statistics:", error);
    }
};

const getDailyStatistics = async ()=>{
    try {
        const res = await statisticsApi.getDailyStatistics();
        stats.value = { ...stats.value, ...res.data };
    } catch (error) {
        const errorMessage =
        error.response?.data?.message || "Error fetching daily statistics";
        toast.error(errorMessage);
        console.error("Error fetching daily statistics:", error);
    }
};

const getThirtyDaysStatistics = async ()=>{
    try {
        const res = await statisticsApi.getThirtyDaysStatistics();
        stats.value = { ...stats.value, ...res.data };
    } catch (error) {
        const errorMessage =
        error.response?.data?.message || "Error fetching 30 days statistics";
        toast.error(errorMessage);
        console.error("Error fetching 30 days statistics:", error);
    }
};
</script>

<style scoped>
.dashboard {
  min-height: 100vh;
}

/* HEADER */
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.header-right {
  display: flex;
  gap: 10px;
}

.search {
  /* background: #1e293b; */
  border: none;
  padding: 8px 12px;
  border-radius: 20px;
  color: #fff;
}

.btn-report {
  background: linear-gradient(135deg, #6366f1, #a855f7);
  border: none;
  padding: 8px 14px;
  border-radius: 10px;
  color: #fff;
}

/* KPI */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.kpi-card {
  padding: 20px;
  border-radius: 16px;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.kpi-card h3 {
  font-size: 22px;
}

.kpi-card p {
  opacity: 0.8;
}

/* gradient */
.purple {
  background: linear-gradient(135deg, #7c3aed, #6366f1);
}

.blue {
  background: linear-gradient(135deg, #06b6d4, #3b82f6);
}

.orange {
  background: linear-gradient(135deg, #fb7185, #f97316);
}

.pink {
  background: linear-gradient(135deg, #a855f7, #ec4899);
}

/* CARD */
.card {
  background: rgba(255, 255, 255, 0.05);
  padding: 16px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
}

/* GRID */
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 16px;
  margin-top: 20px;
}

/* canvas */
canvas {
  margin-top: 10px;
}

.sortTime {
  position: relative;
  display: inline-block;
  padding: 10px 14px;
  border-radius: 10px;
  background: linear-gradient(135deg, #6366f1, #a855f7);
  cursor: pointer;
  color: #fff;
}

/* POPUP */
.popover {
  position: absolute;
  /* top: 120%;
  right: 0; */
  top: 16%;
  right: 16%;
  z-index: 100;
}

.popover-inner {
  width: 220px;
  background: linear-gradient(135deg, #6366f1, #a855f7);
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  animation: fadeIn 0.5s ease;
}

/* option */
.option {
  padding: 10px;
  border-radius: 8px;
  color: #e5e7eb;
  cursor: pointer;
  transition: 0.2s;
}

.option:hover {
  background: #334155;
}

/* divider */
.divider {
  height: 1px;
  background: #334155;
  margin: 8px 0;
}

/* custom */
.custom-range {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.custom-range span {
  color: #e5e7eb;
}

.custom-range input {
  border: none;
  border-radius: 6px;
  padding: 6px;
}

.custom-range button {
  background: #a7a8c9;
  border: none;
  border-radius: 6px;
  padding: 6px;
  color: #fff;
}
.custom-range button:hover {
  background: #38383f;
}

/* animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
